import { Skeleton, Stack, styled } from "@mui/material";
import { styledOmitPropsOptions } from "../../theme/styled.helpers";
import { HeadingM } from "../Typography";

export const DocumentsListContainer = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        px: { xs: theme.spacing(2), md: theme.spacing(4) },
        py: { xs: theme.spacing(4), md: theme.spacing(2) },
        mb: theme.spacing(6),
    }),
);

export const DocumentsListHeaderRow = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: "row",
        justifyContent: "space-between",
        mb: theme.spacing(0),
    }),
);

export const DocumentsListItems = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        gap: theme.spacing(4),
        alignItems: "flex-start",
    }),
);

export const DocumentSkeletonRow = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        width: "100%",
        flexDirection: "row",
        alignItems: "center",
        gap: theme.spacing(4),
    }),
);

export const DocumentSkeletonIcon = styled(Skeleton)(({ theme }) =>
    theme.unstable_sx({
        width: theme.spacing(4),
        height: theme.spacing(4),
    }),
);

export const DocumentSkeletonTextContainer = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexGrow: 1,
        gap: theme.spacing(1),
    }),
);

export const DocumentSkeletonLine = styled(Skeleton)(({ theme }) =>
    theme.unstable_sx({
        width: "100%",
        height: theme.spacing(5),
    }),
);

export const EmptyStateWrapper = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        pt: theme.spacing(2),
    }),
);

export const YearHeading = styled(
    HeadingM,
    styledOmitPropsOptions,
)<{ $withTopPadding: boolean }>(({ theme, $withTopPadding }) =>
    theme.unstable_sx({
        mb: theme.spacing(4),
        pt: $withTopPadding ? theme.spacing(4) : 0,
    }),
);

export const ErrorWrapper = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        pt: theme.spacing(2),
        width: "100%",
    }),
);

export const HalfWidthStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        width: { xs: "100%", md: "50%" },
    }),
);
